<template>
  <div class="col-12">
    <div class="card">
      <div class="card-body">
        <div class="d-flex">
          <div>
            <h3 class="card-title"><i class="ti-check-box"></i>{{ performanceData.name }}</h3>
          </div>
        </div>

        <!-- 1. Add edit -->
        <div  v-bind:class="{'error' : error.length > 0}" v-if="!currentPerformance">
          <p>{{ $t("Performance registered by") }} {{ userData.firstname }} {{ userData.lastname }}:</p>
          <div class="form-horizontal">
            <div class="form-group row m-b-10">
              <div class="col-sm-8">
                <input v-model="performance" name="performance" class="form-control btn-rounded" type="text">
              </div>
              <div class="col-sm-4">
                <button @click="setPerformance" class="btn-sm btn-rounded btn-info"><i class="ti-check"></i> {{ $t("Confirm") }} </button>
              </div>
              <div v-if="error.length > 0" class="col-sm-12 help-block">
                <ul role="alert">
                  <li><small>{{ error }}</small></li>
                </ul>
              </div>
            </div>
            <div class="col-sm-12 text-muted">{{ performanceData.KpiUnit.name }} / {{ performanceData.KpiPeriod.name }}</div>
          </div>
        </div>

        <div v-else>
          <p>{{ $t("Performance") }} {{ currentPerformance.modified.date | formatDate }} {{ $t("by") }} {{ userData.firstname }} {{ userData.lastname }}:</p>
          <div class="row col-sm-12">
            <div style="display: inherit; align-self: center; padding-right: 1rem;">
              <div><span style="padding-right: .2rem; font-size: 2.5rem">{{ currentPerformance.value }}</span></div>
              <div class="text-muted" style="align-self: center"> {{ performanceData.KpiUnit.name }} / {{ performanceData.KpiPeriod.name }} </div>
              </div>
            <a style="align-self: center" @click="putPerformance" id="disable-it"><i class="ti-check-box"></i> {{ $t("Change") }} </a>
          </div>

          <div v-if="currentPerformance.target_met === '0'">
            <hr>
            <div class="col-12 row">
              <div class="col-lg-8 col-md-8 text-danger">
                <span><i class="ti-info"></i>{{ $t("The performance doesn't meet the target of ") }} {{ currentPerformance.target }} {{ performanceData.KpiUnit.name }}/{{ performanceData.KpiPeriod.name }}, {{ $t("please specify the reason(s):") }}</span>
              </div>
              <div class="col-lg-4 col-lg-4">
              <a style="display: inline-block; white-space: nowrap;" @click="addCause" v-if="!putCause" class="button btn-rounded btn-info"><i class="ti-plus"></i> {{ $t("Add cause") }}</a>
              </div>
            </div>
            <div v-if="addCauseInput" class="form-horizontal">
              <div class="form-group row m-b-10 m-t-20 p-b-10">
                <label for="performance-problem" class="col-sm-12 control-label">{{ $t('Add cause') }}</label>
                <div class="col-sm-12">
                  <div class="input-group">
                    <select class="form-control btn-rounded" id="performance-problem" v-model="performanceProblem">
                      <option disabled value="0">{{ $t("Please select reason") }}</option>
                      <option v-for="problem in problems" :value="problem.uid">{{ Number(problem.depth) | depthFilter }}{{ problem.name }}</option>
                      <!--<option v-for="problem in problems" :value="problem.uid">{{ problem.name }}</option>-->
                    </select>
                  </div>
                </div>


                <div class="m-t-10 col-sm-12">
                  <div class="input-group">
                    <textarea id="action-description" class="form-control" rows="5" v-model="description"></textarea>
                  </div>
                  <div class="help-block">
                    <ul role="alert">
                      <li v-for=""><small></small></li>
                    </ul>
                  </div>
                </div>
                <div v-bind:class="{'error' : error.length > 0}" class="row m-t-10 col-md-12">
                  <p class="col-md-8">{{ $t("Total loss due to this cause") }}</p>
                  <input type="text" class="col-md-4 btn-rounded" v-model="amount" required>
                  <div class="help-block" style="width: 100%">
                    <ul role="alert" style="text-align: right">
                      <li><small>{{ error }}</small></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="addCauseInput">
            <a @click="addCause" v-if="!putCause" class="button btn-rounded btn-info m-b-10"><i class="ti-plus"></i> {{ $t("Add cause") }}</a>
            <a @click="addCause" v-else class="button btn-rounded btn-info m-b-10"><i class="ti-plus"></i> {{ $t("Edit cause") }}</a>
            <a v-if="addCauseInput" @click="addCauseInput = false">{{ $t("Cancel") }}</a>
            </div>

            <div v-if="!addCauseInput && foundProblems.length > 0">
              <div class="table-responsive m-t-20">
                <table class="table vm no-th-brd pro-of-month">
                  <tbody>
                  <tr v-for="(problem, index) in foundProblems">
                    <td>
                      <h6>{{ problem.KpiProblemCause.name }}</h6><small class="text-muted">{{ problem.note }}</small>
                    </td>
                    <td>
                      <small class="text-muted">{{ problem.loss }}</small>
                    </td>
                    <td>
                      <a @click="editCause(problem, index)">{{ $t("edit") }}</a>
                    </td>
                    <td>
                      <a @click="removeCause(problem.uid, index)">{{ $t("remove") }}</a>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import apiHelper from '../mixins/APIHelper';

  export default {
    props: {
      content: {
        default: []
      }
    },
    name: "PerformanceWidget",
    data: function() {
      return {
        performanceData: this.content,
        currentPerformance: false,
        userData: apiHelper.getUserData(),
        performance: 0,
        meeting_uid: this.$route.params.id,
        put: false,
        performance_uid: 0,
        addCauseInput: false,
        performanceProblem: 0,
        description: "",
        amount: 0,
        problems: [],
        foundProblems: [],
        problemIndex: 0,
        putCause: false,
        error: "",
        problem_uid: ""
      }
    },
    created() {
      this.foundProblems = [];

      if (String(this.content.current_performance) !== 'false') {
        this.currentPerformance = this.content.current_performance;
        this.performance_uid = this.content.current_performance.uid;
        this.foundProblems = this.content.current_performance.ProblemRegistrations;
        this.performance = this.currentPerformance.value;
        this.put = true;
      }
    },
    beforeDestroy() {
      if (this.currentPerformance !== false) {
        this.content.current_performance = this.currentPerformance;
        this.content.current_performance.uid = this.performance_uid;
        this.content.current_performance.ProblemRegistrations = this.foundProblems;
      }
    },
    methods: {
      // set the performance
      setPerformance: function() {
        let vm = this;
        let data_to_send = {
          "performance" : vm.performance
        };

          if (!vm.put) {
            apiHelper.postResource("/api/kpi/" + vm.performanceData.uid + "/performance/" + vm.meeting_uid, data_to_send).then((data) => {
              if (data.status === 422) {
                vm.error = vm.$t("Please fill in a valid number.");
                return;
              }
              vm.error = "";
              vm.currentPerformance = data;
              vm.performance = data.value;
              vm.performance_uid = data.uid;
            });
          } else {
            apiHelper.putResource("/api/kpi/" + vm.performanceData.uid + "/performance/" + vm.performance_uid, data_to_send).then((data) => {
              if (data.status === 422) {
                vm.error = vm.$t("Please fill in a valid number.");
                return;
              }
              vm.error = "";
              vm.currentPerformance = data;
              vm.performance = data.value;
              vm.put = false;
              vm.$notify({
                group: "notification",
                title: vm.$t("Success"),
                text: vm.$t("Performance registered successfully"),
                type: 'success'
              });
            });
          }
      },

      // Removes a cause from the list
      removeCause: function(value, index) {
        let vm = this;

        apiHelper.delResource("/api/kpi/" + vm.performanceData.uid + "/problem/" + value).then((data) => {
          vm.foundProblems.splice(index, 1);
        })
      },

      // Make the set perfomance go to put mode
      putPerformance: function () {
        this.put = true;
        this.performance = this.currentPerformance.value;
        this.performance_uid = this.currentPerformance.uid;
        this.currentPerformance = false;
      },

      addCause: function () {
        let vm = this;

        if (vm.addCauseInput) {
          if (vm.performanceProblem === 0) {
            vm.$notify({
              group: "notification",
              title: vm.$t("Error"),
              text: vm.$t("Please make sure you select a cause."),
              type: 'error'
            });
          } else {
            let data_to_send = {
              "loss": vm.amount,
              "note": vm.description,
              "performance-uid": vm.currentPerformance.uid
            };

            if (!vm.putCause) {
              apiHelper.postResource("/api/kpi/" + vm.performanceData.uid + "/problem/" + vm.performanceProblem, data_to_send).then((data) => {
                if (data.status === 422) {
                  vm.error = "Please make sure you fill in a float number.";
                  return;
                }
                vm.error = "";
                vm.foundProblems.push(data);
                vm.addCauseInput = false;
                vm.amount = 0;
                vm.description = "";
                vm.performanceProblem = 0;
                vm.$notify({
                  group: "notification",
                  title: vm.$t("Success"),
                  text: vm.$t("Reason added successfully"),
                  type: 'success'
                });
              });
            } else {
              apiHelper.putResource("/api/kpi/" + vm.performanceData.uid + "/problem/" + vm.problem_uid, data_to_send).then((data) => {
                vm.foundProblems[vm.problemIndex] = data;
                if (data.status === 422) {
                  vm.error = "Please make sure you fill in a float number.";
                  return;
                }
                vm.error = "";
                vm.putCause = false;
                vm.addCauseInput = false;
                vm.amount = 0;
                vm.description = "";
                vm.performanceProblem = 0;
                vm.$notify({
                  group: "notification",
                  title: vm.$t("Success"),
                  text: vm.$t("Reason added successfully"),
                  type: 'success'
                });
              });
            }
          }
        } else {
          vm.addCauseInput = true;

          apiHelper.getResource("/api/kpi/" + vm.performanceData.uid + "/problem-causes").then((data) => {
            vm.problems = data;
          });


        }
      },

      editCause: function (value, index) {
        let vm = this;
        vm.problem_uid = value.uid;
        vm.amount = value.loss;
        vm.description = value.note;
        vm.performanceProblem = value.KpiProblemCause.uid;
        vm.problemIndex = index;
        vm.putCause = true;


        if (vm.problems.length === 0) {
          apiHelper.getResource("/api/kpi/" + vm.performanceData.uid + "/problem-causes").then((data) => {
            vm.problems = data;
          });
        }

        this.addCauseInput = true;
      }
    },
    computed: {
      // Find the height for the scrollbox of the actions
      findHeight: function () {
        if (this.foundProblems.length > 2) {
          return "overflow-y: scroll; height: 240px;"
        } else {
          let h = String(this.foundProblems.length * 80);
          return "overflow-y: hidden; height: " + h + "px;";
        }
      }
    },
    watch: {
      content: function (value) {
        this.currentPerformance = value;
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/PerformanceWidget.vue